import apiService from "@/lib/api";

const NOTIFICATION_BASE = "/api/v2/notification";

export const NotificationService = {
  fetUnreadCount: async (params = {}) => {
    try {
      const response = await apiService.getSecure(`${NOTIFICATION_BASE}/unread-count`, { params });
      return response.data;
    } catch (error) {
      console.error("Error while fetching notifications:", error);
      throw error;
    }
  },

  fetNotificationList: async (params = {}) => {
    try {
      const response = await apiService.getSecure(`${NOTIFICATION_BASE}/list`, { params });
      return response.data;
    } catch (error) {
      console.error("Error while fetching notifications:", error);
      throw error;
    }
  },

  notificationMarkRead: async (notificationIds) => {
    try {
      const response = await apiService.patch(`${NOTIFICATION_BASE}/read`, {
        notification_ids: notificationIds,
      });
      return response.data;
    } catch (error) {
      console.error("Error while marking notifications as read:", error);
      throw error;
    }
  },

  // PATCH /read-all takes no body — it reads the user from the token.
  notificationMarkAllRead: async () => {
    try {
      const response = await apiService.patch(`${NOTIFICATION_BASE}/read-all`);
      return response.data;
    } catch (error) {
      console.error("Error while marking all notifications as read:", error);
      throw error;
    }
  },
};
